import React, { type FC } from 'react';
import classes from '../styles/index.module.css';
import { ToolNavigationCollapsedTooltipLink } from './ToolNavigationCollapsedTooltipLink';
import { urlToTestId } from '../../../../../ReactSharedScripts/modules/toolNavigation/utils';
import { useTranslationAPI } from '../../../../../ReactSharedScripts/modules/translations';
import { useToolNavigationDataProvider } from '../../../../../ReactSharedScripts/modules/toolNavigation/components/ToolNavigationDataProvider';

export const ToolNavigationCollapsedFooterTooltipList: FC = () => {
	const navData = useToolNavigationDataProvider();
	const { translate } = useTranslationAPI();

	return (
		<div className={classes.toolNavigationCollapsedTooltipList}>
			{navData.footerNavigationItems.map(({ titleCode, url }) => (
				<ToolNavigationCollapsedTooltipLink
					key={url}
					title={translate(titleCode)}
					url={url}
					data-tool-navigation-module-link-name={urlToTestId(url)}
				/>
			))}
		</div>
	);
};
